import { render, staticRenderFns } from "./MarketplaceEditGeneralTab.vue?vue&type=template&id=fd65b770&scoped=true&"
import script from "./MarketplaceEditGeneralTab.vue?vue&type=script&lang=js&"
export * from "./MarketplaceEditGeneralTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd65b770",
  null
  
)

export default component.exports